import * as Dialog from '@radix-ui/react-dialog';
import { useEffect } from 'react';

interface Props {
    title?: string;
    children?: React.ReactNode;
    wrapClassNm?: string;
    contClassNm?: string;
    onClose?: () => void;
}

export function ModalLayout({ title, children, wrapClassNm, contClassNm, onClose }: Props) {
    useEffect(() => {
        return () => {
            onClose && onClose();
        };
    }, []);

    return (
        <div className={`pop_wrap${wrapClassNm ? ` ${wrapClassNm}` : ''}`}>
            <div className="modal_header">
                <div className="title">{title}</div>
            </div>
            <div className={`pop_contents${contClassNm ? ` ${contClassNm}` : ''}`}>{children}</div>
            <Dialog.Close className="btn-x btn-x-white">
                <span className="sr-only">팝업 닫기</span>
            </Dialog.Close>
        </div>
    );
}
